export const getDataFromLocalStorage = (storageKey: string) => {
  return JSON.parse(localStorage.getItem(storageKey) as string);
};

export const setDataToLocalStorage = (
  storageKey: string,
  dataToBeStored: object,
) => {
  localStorage.setItem(storageKey, JSON.stringify(dataToBeStored));
};
